import { useIntl } from 'react-intl';
import { renderPDCItemValue } from '@package/helpers';

const PuntiDiContatto = ({ content, className = '' }) => {
  const intl = useIntl();

  return content.punto_di_contatto.length > 0 ? (
    <div>
      {content.punto_di_contatto.map((pdc) => {
        const contact = pdc?.value_punto_contatto;
        return contact.map((el, index) => {
          return (
            <span key={el['__key__']} className={className}>
              <strong>
                <span>{el.pdc_type}</span>
                <span className="pdc-desc">
                  {el.pdc_desc ? ` - ${el.pdc_desc}` : ''}:{' '}
                </span>
              </strong>
              {renderPDCItemValue(el, intl)}
            </span>
          );
        });
      })}
    </div>
  ) : (
    <></>
  );
};

export default PuntiDiContatto;
